import React, { ReactElement } from 'react';

interface EmailFieldProps {
  email?: string;
}

const sendTo = (email: string): string => (location.href = `mailto:${email.replace('(at)', '@')}`);

// eslint-disable-next-line react/prop-types
export default function EmailField({ email }: EmailFieldProps): ReactElement | null {
  if (email) {
    return (
      <div>
        <a
          href="#"
          onClick={(e): void => {
            e.preventDefault();
            sendTo(email);
          }}
        >
          {email}
        </a>
      </div>
    );
  }
  return null;
}
